import ListItem from '../../components/ListItem';
import CourseWidgetSkeleton from '../CourseWidget/Skeleton';
import { StyledList } from './styles';

export interface CourseListSkeletonProps {
  /** @default 3 */
  numItems?: number;
}

const CourseListSkeleton = ({ numItems = 3 }: CourseListSkeletonProps) => {
  return (
    <StyledList>
      {new Array(numItems).fill(<div />).map((_, index) => (
        <ListItem key={index}>
          <CourseWidgetSkeleton />
        </ListItem>
      ))}
    </StyledList>
  );
};

export default CourseListSkeleton;
